import {AfterViewInit, Component, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LoadingComponent} from '../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../components/generic/message/message.component';
import {ViewService} from '../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {ErrorType} from '../../../../../model/error-type';
import {DatePicker} from 'primeng/datepicker';
import {Subscription} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {DateHelper} from '../../../../../helper/date.helper';
import {TranslatePipe} from '@ngx-translate/core';
import {
  PlayerProfileCalendarTableComponent
} from './player-profile-calendar-table/player-profile-calendar-table.component';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {
  PlayerProfileCalendarNotificationComponent
} from './player-profile-calendar-notification/player-profile-calendar-notification.component';
import {Divider} from 'primeng/divider';
import {
  PlayerProfileProFeatureComponent
} from '../../player-profile-register/player-profile-pro-feature/player-profile-pro-feature.component';
import {Panel} from 'primeng/panel';
import {CalendarItemEvent} from '../../../model/calendar-item-event';
import {SwitchComponent} from '../../../../shared/common/switch/switch.component';
import {PlayerProfile} from '../../../model/player-profile';
import {PlayerSessionService} from '../../../service/player-session.service';
import {FrontendNotificationService} from '../../../../frontend/service/frontend-notification.service';
import {CdkCopyToClipboard} from '@angular/cdk/clipboard';
import {SessionService} from '../../../../../services/session.service';
import {FlutterService} from '../../../../../services/app/flutter.service';

@Component({
  selector: 'app-player-profile-calendar',
  imports: [
    LoadingComponent,
    MessageComponent,
    DatePicker,
    FormsModule,
    DatePipe,
    TranslatePipe,
    PlayerProfileCalendarTableComponent,
    Button,
    Tooltip,
    PlayerProfileCalendarNotificationComponent,
    Divider,
    PlayerProfileProFeatureComponent,
    Panel,
    SwitchComponent,
    CdkCopyToClipboard
  ],
  templateUrl: './player-profile-calendar.component.html',
  styleUrl: './player-profile-calendar.component.scss'
})
export class PlayerProfileCalendarComponent implements OnInit, OnDestroy, AfterViewInit
{
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  public restErrorHelper = inject(RestErrorHelper);
  public playerSessionService = inject(PlayerSessionService);
  private frontendNotificationService = inject(FrontendNotificationService);
  private sessionService = inject(SessionService);
  private flutterService = inject(FlutterService);

  @ViewChild('datePicker') datePicker!: DatePicker;

  isLoading: boolean;
  errorMsg: ErrorType;
  isSavingIcs: boolean;
  playerProfile: PlayerProfile;
  isPro: boolean;
  data: CalendarItemEvent[];
  dataSelectedDate: CalendarItemEvent[];
  initialized = false;
  viewSubscription: Subscription;
  reload: boolean;
  selectedDate: Date;
  today: Date;
  upcomingEvents: number;
  nextEventDisabled: boolean;
  previousEventDisabled: boolean;

  currentMonth: number;
  currentYear: number;
  numberOfMonths: number;

  runsInApp = this.frontendNotificationService.runsInApp;
  system = this.frontendNotificationService.system;

  ngOnInit(): void
  {
    this.isPro = this.playerProfileService.playerAuthenticationService.isProVersion();
    this.today = DateHelper.getTodayAtStart();
    this.initMonths();
    this.loadData();
    this.viewSubscription = this.view.onSizeChanged.subscribe(() => this.refreshCalendarView());
    this.playerProfile = this.playerSessionService.playerProfileObject;
    console.log('playerProfile: ', this.playerProfile);
  }

  ngAfterViewInit(): void
  {
    /*console.log('1: ' + this.datePicker?.currentMonth + '/' + this.datePicker?.currentYear);
    console.log('1: ', this.datePicker?.months);
    setTimeout(() => console.log('2: ', this.datePicker?.months), 500);*/
  }

  ngOnDestroy(): void
  {
    this.viewSubscription?.unsubscribe();
  }

  private initMonths(): void
  {
    this.numberOfMonths = this.view.isMobile ? 1 : (this.view.isMobile960 ? 2 : 3);
    const now = new Date();
    this.currentMonth = now.getMonth();
    this.currentYear = now.getFullYear();
    console.log('Init Calendar, currentMonth: ' + this.currentMonth + ', currentYear: ' + this.currentYear +
      ', numberOfMonths: ' + this.numberOfMonths);
  }

  public monthChanged(event: any): void
  {
    setTimeout(() =>
    {
      console.log('calendarShow: ', this.datePicker?.months, event);
      if (this.datePicker?.months?.length > 0)
      {
        const firstMonth = this.datePicker.months[0];
        this.currentMonth = firstMonth.month;
        this.currentYear = firstMonth.year;

        console.log('monthChanged(), currentMonth: ' + this.currentMonth + ', currentYear: ' + this.currentYear +
          ', numberOfMonths: ' + this.numberOfMonths);
        // this.loadData();
      }
    });
  }

  private refreshCalendarView(): void
  {
    this.reload = true;
    setTimeout(() => this.reload = false);
  }

  public loadData(): void
  {
    if (!this.isPro)
      return;
    this.isLoading = true;
    this.errorMsg = undefined;
    this.data = undefined;

    this.playerProfileService.getCalendarEvents().subscribe({
      next: response =>
      {
        console.log('PlayerProfile Kalender geladen', response);
        this.isLoading = false;
        this.data = response;
        this.initData();
        setTimeout(() => this.initialized = true, 100);
      },
      error: error =>
      {
        this.isLoading = false;
        console.log('Fehler bei "loadData"', error);
        this.errorMsg = this.restErrorHelper.getErrorType(error);
        this.initialized = true;
      }
    });
  }

  private initData(): void
  {
    if (!this.data)
      return;

    this.upcomingEvents = 0;
    for (const playerEvent of this.data)
    {
      if (playerEvent.date >= this.today)
      {
        this.upcomingEvents++;
        if (!this.selectedDate)
          this.selectedDate = playerEvent.date;  // Nächstes Event
      }
    }

    if (!this.selectedDate)
      this.selectedDate = new Date();

    setTimeout(() => this.onDateSelected());
  }

  public isDateSelectedFuture(date: any): boolean
  {
    if (this.data && !date.otherMonth)
    {
      // console.log('isDateSelected: ', date);
      for (const playerEvent of this.data)
      {
        if (playerEvent.eventYear > 0 && playerEvent.date && playerEvent.date >= this.today &&
            date.year === playerEvent.eventYear && date.month === playerEvent.eventMonth && date.day === playerEvent.eventDay)
        {
          return true;
        }
      }
    }
    return false;
  }

  public isDateSelectedBack(date: any): boolean
  {
    if (this.data && !date.otherMonth)
    {
      for (const playerEvent of this.data)
      {
        if (playerEvent.eventYear > 0 && playerEvent.date && playerEvent.date < this.today &&
          date.year === playerEvent.eventYear && date.month === playerEvent.eventMonth && date.day === playerEvent.eventDay)
        {
          return true;
        }
      }
    }
    return false;
  }

  public onDateSelected(): void
  {
    if (this.selectedDate && this.data)
    {
      this.dataSelectedDate = this.data.filter(e => this.selectedDate.getFullYear() === e.eventYear &&
        this.selectedDate.getMonth() === e.eventMonth && this.selectedDate.getDate() === e.eventDay);

      console.log('dataSelectedDate', this.dataSelectedDate);
      this.nextEventDisabled = this.getNextEventDate(1) === undefined;
      this.previousEventDisabled = this.getNextEventDate(-1) === undefined;
    }
  }

  public selectEvent(direction: number): void
  {
    console.log('selectEvent, direction: ' + direction);
    const date = this.getNextEventDate(direction);
    if (date)
    {
      console.log('Nächster Tag ausgewählt: ' + date);
      this.selectedDate = date;
      this.onDateSelected();
    }
    else
    {
      console.log('Kein nächstes Event gefunden');
    }
  }

  private getNextEventDate(direction: number): Date
  {
    if (this.selectedDate && this.data)
    {
      if (direction === 2)
        return this.data[this.data.length - 1].date;
      else if (direction === -2)
        return this.data[0].date;
      else if (direction > 0)
      {
        for (const event of this.data)
        {
          if (event.date.getFullYear() > this.selectedDate.getFullYear() ||
             (event.date.getFullYear() === this.selectedDate.getFullYear() && event.date.getMonth() > this.selectedDate.getMonth()) ||
             (event.date.getFullYear() === this.selectedDate.getFullYear() && event.date.getMonth() === this.selectedDate.getMonth() && event.date.getDate() > this.selectedDate.getDate()))
          {
            // console.log('Nächster Tag ausgewählt: ' + event.date);
            return event.date;
          }
        }
      }
      else if (direction < 0)
      {
        for (let i = this.data.length - 1; i >= 0; i--)
        {
          const date = this.data[i].date;
          if (date.getFullYear() < this.selectedDate.getFullYear() ||
              (date.getFullYear() === this.selectedDate.getFullYear() && date.getMonth() < this.selectedDate.getMonth()) ||
              (date.getFullYear() === this.selectedDate.getFullYear() && date.getMonth() === this.selectedDate.getMonth() && date.getDate() < this.selectedDate.getDate()))
          {
            // console.log('Nächster Tag ausgewählt: ' + event.date);
            return date;
          }
        }
      }
    }
    return undefined;
  }

  public saveIcsActive(): void
  {
    console.log('saveIcsActive: ' + this.playerProfile.icsActive);
    this.isSavingIcs = true;

    const body = {
      icsActive: this.playerProfile.icsActive
    };

    this.playerProfileService.updateProfileField(body, true).subscribe({
      next: response =>
      {
        console.log('PlayerProfile icsActive gespeichert', response);
        this.isSavingIcs = false;
        this.playerProfile.icsActive = response.icsActive;
        this.playerProfile.icsFilename = response.icsFilename;
      },
      error: error =>
      {
        this.isSavingIcs = false;
        this.playerProfile.icsActive = !this.playerProfile.icsActive;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  public subscribeInAppleCalendar(): void
  {
    if (this.playerProfile.icsFilename)
    {
      const appleUrl = this.playerProfile.icsFilename
        .replace('http:', 'webcal:')
        .replace('https:', 'webcal:');

      if (this.frontendNotificationService.runsInApp())
        this.flutterService.openCustomUrl(appleUrl);
      else window.open(appleUrl, '_blank');
    }
  }

  public subscribeInYourCalendar(): void
  {
    // https://calendar.google.com/calendar/u/0/r/settings/addbyurl
    const url = this.sessionService.languageCode === 'de' ?
      'https://2k-dartsoftware.freshdesk.com/support/solutions/articles/103000415805' :
      'https://2k-dartsoftware.freshdesk.com/support/solutions/articles/103000415806';

    window.open(url, '_blank');
  }
}
